(function () {
  function init() {
    document.querySelectorAll('.prgrid-variant-chips').forEach(function (chipsWrap) {
      if (chipsWrap.dataset.chipInit) return;
      chipsWrap.dataset.chipInit = '1';

      var card = chipsWrap.closest('[data-product-id]');
      if (!card) return;

      var jsonEl = card.querySelector('[data-variants-json]');
      if (!jsonEl) return;

      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var submitBtn = card.querySelector('.quick-add__submit');
      var formInput = card.querySelector('.prgrid-variant-input');

      function getSelected() {
        var result = [];
        chipsWrap.querySelectorAll('.prgrid-option-row').forEach(function (row) {
          var active = row.querySelector('.prgrid-variant-chip.is-active');
          result.push(active ? active.dataset.optionValue : null);
        });
        return result;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return opts.every(function (val, i) {
            return v['option' + (i + 1)] === val;
          });
        }) || null;
      }

      function updateBtn(variant) {
        if (!submitBtn) return;

        var txtEl = submitBtn.querySelector('.prgrid-addtocart-txt-style');
        var priceWrap = submitBtn.querySelector('.prgrid-btn-price');
        var currentEl = priceWrap && priceWrap.querySelector('.prgrid-btn-price__current');
        var compareEl = priceWrap && priceWrap.querySelector('.prgrid-btn-price__compare');
        var addText = submitBtn.dataset.addToCartText || 'Add to cart';
        var soldText = submitBtn.dataset.soldOutText || 'Sold out';

        if (!variant || !variant.available) {
          submitBtn.disabled = true;
          if (txtEl) txtEl.textContent = soldText;
          if (priceWrap) priceWrap.style.display = 'none';
        } else {
          submitBtn.disabled = false;
          if (txtEl) txtEl.textContent = addText;
          if (priceWrap) priceWrap.style.display = '';
          if (currentEl) currentEl.textContent = variant.price_formatted;
          if (compareEl) {
            if (variant.compare_at_price > variant.price) {
              compareEl.textContent = variant.compare_at_price_formatted;
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
        }

        if (formInput && variant) formInput.value = variant.id;
      }

      chipsWrap.addEventListener('click', function (e) {
        var chip = e.target.closest('.prgrid-variant-chip');
        if (!chip) return;
        var row = chip.closest('.prgrid-option-row');
        row.querySelectorAll('.prgrid-variant-chip').forEach(function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        updateBtn(findVariant(getSelected()));
      });

      updateBtn(findVariant(getSelected()));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();